export const PANEL_FONT_FAMILY = "Patchwork Panel";

let panelFontsReady: Promise<void> | undefined;

export function ensurePanelFontsReady() {
  if (typeof document === "undefined" || !document.fonts) return Promise.resolve();
  panelFontsReady ??= Promise.all([
    document.fonts.load(`600 16px "${PANEL_FONT_FAMILY}"`),
    document.fonts.load(`800 16px "${PANEL_FONT_FAMILY}"`),
    document.fonts.load(`900 16px "${PANEL_FONT_FAMILY}"`),
  ])
    .then(() => undefined)
    .catch(() => undefined);
  return panelFontsReady;
}
